import {NgModule}             from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutComponent}      from './layout/components/layout/layout.component';
import {TokenResolver}        from './shared/service/token.resolver';
import {AuthGuard}            from './core/guards/auth.guard';

const routes: Routes = [
    {
        path: 'login',
        loadChildren: './login/login.module#LoginModule'
    },
    {
        path: '',
        component: LayoutComponent,
        canActivateChild: [AuthGuard],
        resolve: {
            token: TokenResolver
        },
        children: [
            {
                path: '',
                loadChildren: './home/home.module#HomeModule'
            },
            {
                path: 'user',
                loadChildren: './user/user.module#UserModule'
            },
            {
                path: 'certificates',
                loadChildren: './certificate/certificate.module#CertificateModule'
            },
            {
                path: 'survey',
                loadChildren: './survey/survey.module#SurveyModule'
            },
            {
                path: 'cme',
                loadChildren: './cme/cme.module#CmeModule'
            },
        ]
    },
    {
        path: '**',
        redirectTo: ''
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
